import Session from "./Session";
import { API_BASE, API_VERSION, HTTP_METHODS } from "../config";
import Validations from "./Validations";

/**
 * Valida las credenciales ingresadas contra el servicio de autenticación de AGD
 *
 * @param {String} username
 * @param {String} password
 * @param {String|Number|null} twoFactorCode
 *
 */

let clearSession = true;

function authenticate(username, password, twoFactorCode) {
	const url = twoFactorCode
		? `account/authenticate?totp=${twoFactorCode}`
		: `account/authenticate`;
	Session.clear();
	return call(
		HTTP_METHODS.post,
		url,
		{
			username: username,
			password: password,
		},
		{}
	).then(async function (response) {
		if (response !== undefined && response.access_token !== null) {
			// Compruebo si el usuario tiene algún rol de AGD
			switch (process.env.REACT_APP_FLAVOR) {
				case "reseller":
					Session.setToken(response.access_token, response.expires_in);
					const resp = await getCurrentUser()
					let isReseller = resp.data != null ? resp.data.reseller : false

					if (!isReseller && !Validations.userIsDisa(response.roles)) {
						Session.clear();
						return {
							success: false,
							reason: "El usuario no está habilitado para el sitio",
						};
					}
					break;
			
				case "base":
					if (!Validations.userIsAGD(response.roles) || Validations.userIsDisa(response.roles)) {
						return {
							success: false,
							reason: "El usuario no está habilitado para el sitio",
						};
					}
					break;
			
				default:
					break;
			}


			// El usuario puede utilizar el sitio
			Session.setToken(response.access_token, response.expires_in);
			Session.setRefreshToken(response.refresh_token);
			Session.setUser({
				userName: response.username,
				isSuperadmin: Validations.userIsSuperadmin(response.roles),
				isAdmin: Validations.userIsAdmin(response.roles),
				isDisa: Validations.userIsDisa(response.roles),
				isDisaAdmin: Validations.userIsDisaAdmin(response.roles),
			});
			return {
				success: true,
			};
		} else {
			return {
				success: false,
			};
		}
	});
}

/**
 * Utilizado cuando el usuario solicita un blanqueo de contraseña
 *
 * @param {*} userName
 * @param {*} email
 */
function recoverPassword(userName, email) {
	return call(
		HTTP_METHODS.get,
		"reset/account/requestPasswordReset/" + email + "?username=" + userName
	);
}

/**
 * Fuerzo el blanqueo de la clave para el usuario indicado.
 *
 * @param {String} userName
 */
function createSecurePassword(userName) {
	let body = {
		username: userName,
	};

	return call(
		HTTP_METHODS.post,
		"reset/account/requestCreateSecurePassword",
		body
	);
}

/**
 * ...
 *
 * @param {String} username
 * @param {Number} totp
 * @returns
 */
function getTotpSecret(username) {
	return apiCallNotVersioned(
		HTTP_METHODS.get,
		"totp/secret?username=" + username,
		undefined,
		false
	);
}

/**
 * ...
 *
 * @param {String} username
 * @param {Number} totp
 * @returns
 */
function enableTotp(username, totp, secret) {
	let body = {
		username: username,
		totp: totp,
		secret: secret,
	};

	return apiCallNotVersioned(HTTP_METHODS.post, "totp/enable", body, false);
}

/**
 * ...
 *
 * @param {String} username
 * @param {Number} totp
 * @returns
 */
function disableTotp(username, totp) {
	let body = {
		username: username,
		totp: totp,
	};

	return apiCallNotVersioned(HTTP_METHODS.post, "totp/disable", body, false);
}

/**
 * Busca una persona en la api rest
 */
function searchPerson(
	option,
	query,
	nombre,
	provincia,
	nacionalidad,
	edadgt,
	edadlt,
	page,
	per_page,
	modo_busqueda
) {
	let url = "";
	if (modo_busqueda === "full") {
		url = `searchFull/?${option}=${escape(query)}`;
	} else {
		url = `person/?${option}=${escape(query)}`;
	}

	if (nombre !== undefined && nombre.length > 0) {
		url += `&nombre=${escape(nombre)}`;
	}

	if (provincia !== undefined && provincia.length > 0) {
		url += `&provincia=${escape(provincia)}`;
	}
	if (nacionalidad !== undefined && nacionalidad.length > 0) {
		url += `&nacionalidad=${escape(nacionalidad)}`;
	}
	if (edadgt !== undefined && edadgt > 0) {
		url += `&edadgt=${edadgt}`;
	}
	if (edadlt !== undefined && edadlt > 0) {
		url += `&edadlt=${edadlt}`;
	}

	if (page !== undefined) {
		url += `&page=${page}`;
	}
	if (per_page !== undefined) {
		url += `&per_page=${per_page}`;
	}

	// Agrego parámetro consulta web
	url += `&web_request=true`;

	return apiCall(HTTP_METHODS.get, url);
}

function getPerson(cuil) {
	return apiCall(HTTP_METHODS.get, `person/${cuil}?web_request=true`);
}

function getPersonPublic(token) {
	return call(HTTP_METHODS.get, `arco/${token}?web_request=true`);
}

function searchCompanies(option, query, page, per_page, modo_busqueda) {
	let url = "";
	if (modo_busqueda === "full") {
		url = `searchFull/?${option}=${query}`;
	} else {
		url = `company/?${option}=${query}`;
	}
	if (page !== undefined) {
		url += `&page=${page}`;
	}
	if (per_page !== undefined) {
		url += `&per_page=${per_page}`;
	}

	// Agrego parámetro consulta web
	url += `&web_request=true`;

	return apiCall(HTTP_METHODS.get, url);
}

function getCompany(cuit) {
	return apiCall(HTTP_METHODS.get, `company/${cuit}?web_request=true`);
}

function searchCarOwners(option, query, page, per_page) {
	var url = `automotor/?${option}=${query}`;
	if (page !== undefined) {
		url += `&page=${page}`;
	}
	if (per_page !== undefined) {
		url += `&per_page=${per_page}`;
	}

	// Agrego parámetro consulta web
	url += `&web_request=true`;

	return apiCall(HTTP_METHODS.get, url);
}

function searchTelefonos(option, query, page, per_page) {
	var url = `telefono/?tel=${query}`;
	if (page !== undefined) {
		url += `&page=${page}`;
	}
	if (per_page !== undefined) {
		url += `&per_page=${per_page}`;
	}

	// Agrego parámetro consulta web
	url += `&web_request=true`;

	return apiCall(HTTP_METHODS.get, url);
}

function getAccount() {
	return apiCall(HTTP_METHODS.get, "account/me/client");
}

function getClientLogo(idCliente) {
	return baseCall(
		HTTP_METHODS.get,
		API_BASE + `clientes/logo/${idCliente}`,
		null,
		{
			Authorization: `Bearer ${Session.getToken()}`,
		}
	).then(function (res) {
		if (res.file) {
			if (res.file.length > 0) {
				Session.setLogo(res.file);
				return true;
			}
		}
		const error = new Error("Cannot load logo");
		throw error;
	});
}

/**
 * Recupera la lista completa de Asociados para autocompletar en el módulo Asociados.
 *
 * @returns
 */
function getCentroDeudorAsociados(nroInstituto) {
	if (!nroInstituto) {
		nroInstituto = "";
	}
	return apiCall(HTTP_METHODS.get, `centroDeudor/asociados/${nroInstituto}`);
}

/**
 * Recupera la lista completa de Asociados para autocompletar en el módulo Asociados.
 *
 * @param {Number} asociadoNumero
 * @param {Number} institutoNumero
 * @returns
 */
function getCentroDeudorAtrasosVigentes(asociadoNumero, institutoNumero) {
	let url = "centroDeudor?";
	if (asociadoNumero && asociadoNumero != 0) {
		url += `asociado=${escape(asociadoNumero)}&`;
	}
	if (institutoNumero && institutoNumero != 0) {
		url += `instituto=${escape(institutoNumero)}`;
	}

	return apiCall(HTTP_METHODS.get, url);
}

/**
 * Recupera la lista completa de Institutos para autocompletar en el módulo Asociados.
 *
 * @returns
 */
function getCentroDeudorInstitutos() {
	return apiCall(HTTP_METHODS.get, `centroDeudor/institutos`);
}

/**
 * Descarga el reporte en PDF con los parámetros suministrados.
 *
 * @param {Number} asociadoNumero
 * @param {Number} institutoNumero
 * @returns
 */
function centroDeudorExportListado(asociadoNumero, institutoNumero) {
	let url = "centroDeudor/exportListado?";
	if (asociadoNumero && asociadoNumero != 0) {
		url += `asociado=${escape(asociadoNumero)}&`;
	}
	if (institutoNumero && institutoNumero != 0) {
		url += `instituto=${escape(institutoNumero)}`;
	}

	return apiCall(HTTP_METHODS.get, url);
}

/**
 * Envío el archivo en una solicitud multipart
 *
 * @param {*} data
 */
function solicitudActualizacionAsociados(data, accion) {
	let formData = new FormData();
	formData.append("file", data);
	formData.append("accion", accion);

	return apiCall(
		HTTP_METHODS.post,
		"centroDeudor/asociados/solicitud",
		formData,
		true
	);
}

function getClient(idCliente) {
	return baseCall(
		HTTP_METHODS.get,
		API_BASE + `clientes/${idCliente}`,
		null,
		{
			Authorization: `Bearer ${Session.getToken()}`,
		}
	);
}

function getAllClients() {
	return baseCall(HTTP_METHODS.get, API_BASE + `clientes`, null, {
		Authorization: `Bearer ${Session.getToken()}`,
	});
}

function changePassword(newPass, oldPass, twoFactorCode) {
	clearSession = false;
	let body = {
		usuario: {
			totp: twoFactorCode,
			oldPassword: oldPass,
			newPassword: newPass,
		},
	};
	return apiCall(HTTP_METHODS.put, "account/me/changepassword", body);
}

function getListUsers() {
	return apiCall(HTTP_METHODS.get, "account/me/listuser");
}

function getUsers(clienteId) {
	return baseCall(
		HTTP_METHODS.get,
		API_BASE + `users/?clienteId=${clienteId}&max=1000`,
		null,
		{
			Authorization: `Bearer ${Session.getToken()}`,
		}
	);
}

function getCurrentUser() {
	return apiCall(HTTP_METHODS.get, "account/me");
}

/**
 * Busca el log de consultas para el usuario especificado entre las fechas indicadas
 *
 * @param {Number} user_id id del usuario a buscar
 * @param {String} fecha_desde fecha en formato iso
 * @param {String} fecha_hasta fecha en formato iso
 * @param {Boolean} porServicio indica si la búsqueda se realiza por servicio (las fechas se toman de ahí)
 * @param {Number} servicio id del servicio a buscar
 * @param {Number} cliente id del cliente a buscar
 * @param {Boolean} consumeCredito indica si se buscan las consultas que consumen crédito
 * @param {Boolean} agruparPorUsuario indica si los resultados se deben agrupar por usuario
 * @returns
 */
function getLog(
	user_id,
	fecha_desde,
	fecha_hasta,
	porServicio,
	servicio,
	cliente,
	consumeCredito,
	agruparPorUsuario
) {
	let url = builLogQueryParams(
		"log",
		user_id,
		fecha_desde,
		fecha_hasta,
		porServicio,
		servicio,
		cliente,
		consumeCredito,
		agruparPorUsuario
	);

	return apiCall(HTTP_METHODS.get, url);
}

/**
 * Descarga el reporte en CSV con los parámetros suministrados.
 *
 * @param {Number} user_id id del usuario a buscar
 * @param {String} fecha_desde fecha en formato iso
 * @param {String} fecha_hasta fecha en formato iso
 * @param {Boolean} porServicio indica si la búsqueda se realiza por servicio (las fechas se toman de ahí)
 * @param {Number} servicio id del servicio a buscar
 * @param {Number} cliente id del cliente a buscar
 * @param {Boolean} consumeCredito indica si se buscan las consultas que consumen crédito
 * @param {Boolean} agruparPorUsuario indica si los resultados se deben agrupar por usuario
 * @returns
 */
function getLogSearchCsv(
	user_id,
	fecha_desde,
	fecha_hasta,
	porServicio,
	servicio,
	cliente,
	consumeCredito,
	agruparPorUsuario
) {
	let url = builLogQueryParams(
		"log/exportCsv",
		user_id,
		fecha_desde,
		fecha_hasta,
		porServicio,
		servicio,
		cliente,
		consumeCredito,
		agruparPorUsuario
	);

	return apiCall(HTTP_METHODS.get, url);
}

/**
 * Devuelve un string con la URL del endpoint incluyendo los parámetros solicitados
 *
 * @param {String} apiResource nombre del recurso de la API
 * @param {Number} user_id id del usuario a buscar
 * @param {String} fecha_desde fecha en formato iso
 * @param {String} fecha_hasta fecha en formato iso
 * @param {Boolean} porServicio indica si la búsqueda se realiza por servicio (las fechas se toman de ahí)
 * @param {Number} servicio id del servicio a buscar
 * @param {Number} cliente id del cliente a buscar
 * @param {Boolean} consumeCredito indica si se buscan las consultas que consumen crédito
 * @param {Boolean} agruparPorUsuario indica si los resultados se deben agrupar por usuario
 * @returns
 */
function builLogQueryParams(
	apiResource,
	user_id,
	fecha_desde,
	fecha_hasta,
	porServicio,
	servicio,
	cliente,
	consumeCredito,
	agruparPorUsuario
) {
	let idParam = "";
	let idServicio = "";
	let idCliente = "";
	let consumeCreditoParam = "";

	if (user_id > 0) {
		idParam = `id=${user_id}&`;
	}
	if (servicio > 0) {
		idServicio = `&servicio=${servicio}&`;
	}
	if (cliente > 0) {
		idCliente = `cliente=${cliente}&`;
	}
	if (consumeCredito === "1") {
		consumeCreditoParam = `consumeCredito=true&`;
	}

	return `${apiResource}/?${consumeCreditoParam}${idParam}${idCliente}${idServicio}from=${fecha_desde}&to=${fecha_hasta}&porServicio=${porServicio}&agruparPorUsuario=${agruparPorUsuario}`;
}

/**
 * Devuelve la cantidad de consultas sobre el cuil dado, agrupadas por rubro
 *
 * @param {Number} cuil
 * @returns JSON Array<LogConsultaRubroDTO>
 */
function getConsultasPorRubro(cuil) {
	return apiCallNotVersioned(HTTP_METHODS.get, `logConsultas/${cuil}/rubros`);
}

function createUser(user) {
	let body = {
		usuario: user,
	};
	return apiCall(HTTP_METHODS.post, "account/me/create", body);
}

function createUserDemo(user) {
	let body = {
		usuario: user,
	};
	return call(HTTP_METHODS.post, "demo/account/create", body);
}

/**
 * Envío la información para completar los datos del usuario.
 * Se utiliza en el primer inicio de sesión de un usuario nuevo.
 *
 * @param {*} user
 */
function completeUserData(user) {
	let body = {
		usuario: user,
	};
	return apiCall(HTTP_METHODS.put, "account/me/completeUserData", body);
}

function modifyUser(user) {
	let body = {
		usuario: user,
	};
	return apiCall(HTTP_METHODS.put, "account/me/update", body);
}

function deleteUser(user) {
	let body = {
		usuario: user,
	};
	return apiCall(HTTP_METHODS.put, "account/me/delete", body);
}

function getNotifications() {
	return apiCall(HTTP_METHODS.get, "notificacion");
}

function markNotificationAsRead(id) {
	let body = {
		notificacion: {
			id: id,
		},
	};

	return apiCall(HTTP_METHODS.post, "notificacion/lectura", body);
}

function requestExtraInfo(id, block, subBlock) {
	let body = {
		idLog: id,
		bloque: block,
		subBloque: subBlock,
	};

	return apiCall(HTTP_METHODS.post, "infoextra", body);
}

function getLocalidades() {
	return apiCall(HTTP_METHODS.get, `localidad`);
}

function getFiltros() {
	return apiCall(HTTP_METHODS.get, "fitro/getFiltros");
}

function getFiltrosOption(id, nombre) {
	return apiCall(
		HTTP_METHODS.get,
		`fitro/getFiltrosOption?id=${id}&nombre=${nombre}`
	);
}

function getCredito() {
	return apiCall(HTTP_METHODS.get, "busquedaEnriquecida/getCredito");
}

function getConsultasEnriquecimientos() {
	return apiCall(
		HTTP_METHODS.get,
		"busquedaEnriquecida/findAllConsultasEnriquecidas"
	);
}

function filtroBusqueda(data) {
	let body = {
		data: data,
	};
	return apiCall(
		HTTP_METHODS.post,
		"busquedaEnriquecida/procesarFiltro",
		body
	);
}

function procesarFile(data) {
	let body = {
		data: data,
	};
	return apiCall(
		HTTP_METHODS.post,
		"busquedaEnriquecida/procesarArchivo",
		body
	);
}

/**
 * Envío el archivo en una solicitud multipart
 *
 * @param {*} data
 */
function procesarScoreBatch(data,twoFactorCode) {
	let formData = new FormData();
	formData.append("file", data);

	return apiCall(HTTP_METHODS.post, `score?source=scoreNav&totp=${twoFactorCode}`, formData, true);
}

function presupuestarConsulta(data) {
	let body = {
		data: data,
	};
	return apiCall(
		HTTP_METHODS.post,
		"busquedaEnriquecida/presupuestarConsulta",
		body
	);
}

function obtenerResumenResultados(data) {
	let body = {
		data: data,
	};
	return apiCall(
		HTTP_METHODS.post,
		"busquedaEnriquecida/obtenerResumenResultados",
		body
	);
}

function descargarResultadoConsulta(data) {
	let body = {
		data: data,
	};
	return apiCall(
		HTTP_METHODS.post,
		"busquedaEnriquecida/descargarResultadoConsulta",
		body
	);
}

function descargarSegmentacion(data) {
	let body = {
		data: data,
	};
	return apiCall(
		HTTP_METHODS.post,
		"busquedaEnriquecida/descargarSegmentacion",
		body
	);
}

function descargarSegmentacionEmpresa(data) {
	let body = {
		data: data,
	};
	return apiCall(
		HTTP_METHODS.post,
		"busquedaEnriquecida/descargarSegmentacionEmpresa",
		body
	);
}

function deleteConsultaEnriquecida(data) {
	let body = {
		data: data,
	};
	return apiCall(
		HTTP_METHODS.post,
		"busquedaEnriquecida/deleteConsultaEnriquecida",
		body
	);
}

function getServiciosByCliente(idCliente) {
	return baseCall(
		HTTP_METHODS.get,
		API_BASE + `tipoServicios/getServiciosByCliente?id=${idCliente}`,
		null,
		{
			Authorization: `Bearer ${Session.getToken()}`,
		}
	);
}

function getListBloqueEnriquecimientoByTipo(tipo) {
	return apiCall(HTTP_METHODS.get, `bloqueEnriquecimiento?tipo=${tipo}`);
}

/**
 * Envío la solicitud de informe previsional sobre el cuil indicado
 * @param {string} cuil
 */
function solicitarInformePrevisional(cuil) {
	return apiCall(HTTP_METHODS.post, `historialPrevisional/?cuil=${cuil}`);
}

/**
 * Solicita el informe proporcionado por Veraz
 *
 * @param {String} sexo indica el sexo de la persona consultada (M|F)
 * @param {String} dni documento de la persona consultada
 * @param {String} cuil cuil de la persona consultada
 * @returns
 */
function getInformeVeraz(tokenCA) {
	let body = {
		token: tokenCA,
	};
	return apiCall(HTTP_METHODS.post, "score/veraz", body);
}

function getFeatureFlag(fetureName) {
	return apiCallNotVersioned(
		HTTP_METHODS.get,
		"features/status/" + fetureName
	);
}

//Validacion email
/* function validarEmail(data) {
	let body = {
		data: data,
	};
	return apiCall(
		HTTP_METHODS.post,
		"/api/v2/disa/emailTotp",
		body
	);
} */
//Envio formulario /api/v2/disa/user

function crearNuevoUsuario(data) {
	let body = data;

	return baseCall(HTTP_METHODS.post, API_BASE + "v2/disa/user", body);
}

function getRangoIngresos() {
	return apiCall(HTTP_METHODS.get, "ingresos/rangos");
}

function sendEmailCode() {
	return apiCallNotVersioned(HTTP_METHODS.post, "totp/email");
}

/**
 * internal functions
 */

function apiCall(method, url, body, isMultiPart) {
	if (Session.isAuthenticated() === true) {
		return call(
			method,
			url,
			body,
			{
				Authorization: `Bearer ${Session.getToken()}`,
			},
			isMultiPart
		);
	} else {
		const error = new Error("Not authenticated");
		error.status = 401;
		throw error;
	}
}

/**
 *
 * @param {*} method
 * @param {*} url
 * @param {*} body
 * @param {*} isMultiPart
 * @returns
 */
function apiCallNotVersioned(method, url, body, isMultiPart) {
	if (Session.isAuthenticated() === true) {
		return baseCall(
			method,
			API_BASE + url,
			body,
			{
				Authorization: `Bearer ${Session.getToken()}`,
			},
			isMultiPart
		);
	} else {
		const error = new Error("Not authenticated");
		error.status = 401;
		throw error;
	}
}

function call(method, url, body, headers, isMultiPart) {
	return baseCall(
		method,
		API_BASE + API_VERSION + url,
		body,
		headers,
		isMultiPart
	);
}

function baseCall(method, url, body, headers, isMultiPart) {
	if (!isMultiPart && method !== HTTP_METHODS.get) {
		if (body === undefined) body = "";

		body = JSON.stringify(body);
	}

	return fetch(url, {
		method: method,
		accept: "application/json",
		headers: headers,
		body: body,
	})
		.then(checkStatus)
		.then(toJson);
}

function checkStatus(response) {
	let changePass = clearSession;
	if (
		response.status === 401 ||
		response.status === 412 ||
		response.status === 418
	) {
		if (clearSession) {
			Session.clear();
		}
		clearSession = true;
	}
	if ((response.status >= 200 && response.status < 300) || !changePass) {
		return response;
	}
	const error = new Error(`HTTP Error ${response.statusText}`);
	error.status = response.status;
	error.statusText = response.statusText;
	error.response = response.json();
	if (response.headers.get("Exception") !== undefined) {
		error.message = response.headers.get("Exception");
	}
	if (response.headers.get("Attempts") !== undefined) {
		error.attempts = response.headers.get("Attempts");
	}
	if (response.status === 412) {
		error.message = response.message;
	}
	throw error;
}

function toJson(response) {
	return response.json();
}

const ApiClient = {
	authenticate,
	centroDeudorExportListado,
	changePassword,
	completeUserData,
	createSecurePassword,
	createUser,
	createUserDemo,
	deleteConsultaEnriquecida,
	deleteUser,
	descargarResultadoConsulta,
	descargarSegmentacion,
	descargarSegmentacionEmpresa,
	disableTotp,
	enableTotp,
	filtroBusqueda,
	getAccount,
	getAllClients,
	getCentroDeudorAsociados,
	getCentroDeudorAtrasosVigentes,
	getCentroDeudorInstitutos,
	getClient,
	getClientLogo,
	getCompany,
	getConsultasEnriquecimientos,
	getConsultasPorRubro,
	getCredito,
	getCurrentUser,
	getFiltros,
	getFiltrosOption,
	getInformeVeraz,
	getListBloqueEnriquecimientoByTipo,
	getListUsers,
	getLocalidades,
	getLog,
	getLogSearchCsv,
	getNotifications,
	getPerson,
	getPersonPublic,
	getServiciosByCliente,
	getTotpSecret,
	getUsers,
	markNotificationAsRead,
	modifyUser,
	obtenerResumenResultados,
	presupuestarConsulta,
	procesarFile,
	procesarScoreBatch,
	recoverPassword,
	requestExtraInfo,
	searchCarOwners,
	searchCompanies,
	searchPerson,
	searchTelefonos,
	solicitarInformePrevisional,
	solicitudActualizacionAsociados,
	//validarEmail,
	crearNuevoUsuario,
	getFeatureFlag,
	getRangoIngresos,
	sendEmailCode,
};

export default ApiClient;



// WEBPACK FOOTER //
// ./src/utils/ApiClient.js